export const FETCH_PAYMENT_CONFIGURATIONS_SUCCESS = 'FETCH_PAYMENT_CONFIGURATIONS_SUCCESS';
export const FETCH_PAYMENT_CONFIGURATIONS_FAILURE = 'FETCH_PAYMENT_CONFIGURATIONS_FAILURE';
export const UNLOCK_IX_WITH_CREDIT_SUCCESS = 'UNLOCK_IX_WITH_CREDIT_SUCCESS';
export const UNLOCK_IX_WITH_CREDIT_FAILURE = 'UNLOCK_IX_WITH_CREDIT_FAILURE';
